import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';
import { common } from '../common';
import { hideGenderIcon } from './helpers/hide-gender-icon';

export const squarePanelFromSearch = mergeMultipleConfigs(
  common.squarePanelFromSearch,
  [hideGenderIcon],
);
